var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActiveGrid = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7730_16262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7730_16262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98081 7.875C3.60194 7.875 3.28125 7.74375 3.01875 7.48125C2.75625 7.21875 2.625 6.89806 2.625 6.51919V3.98081C2.625 3.60194 2.75625 3.28125 3.01875 3.01875C3.28125 2.75625 3.60194 2.625 3.98081 2.625H6.51919C6.89806 2.625 7.21875 2.75625 7.48125 3.01875C7.74375 3.28125 7.875 3.60194 7.875 3.98081V6.51919C7.875 6.89806 7.74375 7.21875 7.48125 7.48125C7.21875 7.74375 6.89806 7.875 6.51919 7.875H3.98081ZM3.98081 15.375C3.60194 15.375 3.28125 15.2438 3.01875 14.9813C2.75625 14.7188 2.625 14.3981 2.625 14.0192V11.4808C2.625 11.1019 2.75625 10.7812 3.01875 10.5188C3.28125 10.2563 3.60194 10.125 3.98081 10.125H6.51919C6.89806 10.125 7.21875 10.2563 7.48125 10.5188C7.74375 10.7812 7.875 11.1019 7.875 11.4808V14.0192C7.875 14.3981 7.74375 14.7188 7.48125 14.9813C7.21875 15.2438 6.89806 15.375 6.51919 15.375H3.98081ZM11.4808 7.875C11.1019 7.875 10.7812 7.74375 10.5188 7.48125C10.2563 7.21875 10.125 6.89806 10.125 6.51919V3.98081C10.125 3.60194 10.2563 3.28125 10.5188 3.01875C10.7812 2.75625 11.1019 2.625 11.4808 2.625H14.0192C14.3981 2.625 14.7188 2.75625 14.9813 3.01875C15.2438 3.28125 15.375 3.60194 15.375 3.98081V6.51919C15.375 6.89806 15.2438 7.21875 14.9813 7.48125C14.7188 7.74375 14.3981 7.875 14.0192 7.875H11.4808ZM11.4808 15.375C11.1019 15.375 10.7812 15.2438 10.5188 14.9813C10.2563 14.7188 10.125 14.3981 10.125 14.0192V11.4808C10.125 11.1019 10.2563 10.7812 10.5188 10.5188C10.7812 10.2563 11.1019 10.125 11.4808 10.125H14.0192C14.3981 10.125 14.7188 10.2563 14.9813 10.5188C15.2438 10.7812 15.375 11.1019 15.375 11.4808V14.0192C15.375 14.3981 15.2438 14.7188 14.9813 14.9813C14.7188 15.2438 14.3981 15.375 14.0192 15.375H11.4808Z",
    fill: "#1E293B"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActiveGrid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/activeGrid.b9bc3b68acee03f94c6268d71caa1826.svg";